import { type Action, createReducer, on } from '@ngrx/store';
import * as PlatformIdentityActions from './platform-identity.actions';
import type { PlatformAdminData } from './platform-identity.models';

export const PLATFORM_IDENTITY_FEATURE_KEY = 'platformIdentity';

export interface PlatformIdentityState {
  admin: PlatformAdminData | null;
  error: string | null;
}

export interface PlatformIdentityPartialState {
  readonly [PLATFORM_IDENTITY_FEATURE_KEY]: PlatformIdentityState;
}

export const initialPlatformIdentityState: PlatformIdentityState = {
  admin: null,
  error: null,
};

const reducer = createReducer(
  initialPlatformIdentityState,
  on(PlatformIdentityActions.setAdmin, (state, { admin }) => ({
    ...state,
    admin,
    error: null,
  })),
  on(PlatformIdentityActions.validateFailed, (state, { error }) => ({
    ...state,
    admin: null,
    error,
  }))
);

export function platformIdentityReducer(
  state: PlatformIdentityState | undefined,
  action: Action
) {
  return reducer(state, action);
}
